import { Drawer, Grid, Typography } from "@mui/material";
import { DrawerProps } from "@mui/material/Drawer";
import { withStyles, WithStyles } from "@mui/styles";
import { DrawerBoxStyleClasses } from "assets/jss/common-styles";
import classNames from "classnames";
import IconButtonClose from "components/Buttons/IconButtonClose";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import * as CSS from "csstype";
import * as React from "react";

export type BoxDrawerExitMode = "backdrop" | "escape" | "exit";

interface IProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    overflow?: CSS.Property.Overflow;
    onClose: (exitMode: BoxDrawerExitMode) => void;
}

type Props = IProps & Omit<DrawerProps, "anchor" | "title" | "onBackdropClick" | "onEscapeKeyDown"> & WithStyles<typeof DrawerBoxStyleClasses>;

const BoxDrawer: React.FC<Props> = (props) => {

    const { className, classes, children, overflow, title, subtitle, onClose, ...rest } = props;

    return (
        <Drawer
            classes={{ paper: classes.paper, root: classes.root }}
            anchor="right"
            onBackdropClick={() => onClose("backdrop")}
            onClose={() => onClose("escape")}
            {...rest}
        >
            <Grid container direction="column" wrap="nowrap" className={classes.container}>

                <Grid item className={classes.titleContainer}>

                    <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start" >
                        <Grid item xs zeroMinWidth>
                            <Typography component="div" noWrap={true} variant="h6" title={typeof (title) == "string" ? title : null} className={classes.title}>{title}</Typography>
                            {
                                subtitle &&
                                <MuiMuted><Typography component="div" noWrap={true} variant="subtitle2" title={typeof (subtitle) == "string" ? subtitle : null}>{subtitle}</Typography></MuiMuted>
                            }
                        </Grid>
                        {
                            <Grid item>
                                <IconButtonClose color="black" size="small" onClick={() => onClose("exit")} />
                            </Grid>
                        }
                    </Grid>

                </Grid>

                <Grid item
                    className={
                        classNames({
                            [classes.contentContainer]: true,
                            ["" + overflow]: overflow != null
                        })
                    }
                >
                    {children}
                </Grid>

            </Grid>

        </Drawer>
    );
};


export default withStyles(DrawerBoxStyleClasses)(BoxDrawer);
